module.exports = __webpack_public_path__ + "static/media/audit1.1e5abab5.svg";